import React from 'react';
import {delLoginCookie, getCookie} from "../utils/api";
import {authConstants} from "../constants/authConstants";
import {useAuthLogoutMutation} from "../redux/api/AuthApi";
import {useDispatch} from "react-redux";
import {websocketMessageTypes} from "./websocket/WebsocketApi";
import ExitIcon from "../assets/images/exit.svg";
import {UseCloseSocketSession} from "../redux/api/DisconnectSocket";
import {authData, setLoadAuth} from "../redux/reducers/auth";

const LogoutBtn = () => {

  const dispatch = useDispatch();
  const currentRefreshToken = getCookie(authConstants.refreshToken);
  const currentAccessToken = getCookie(authConstants.accessToken);
  const serviceToolsTokenAdmin = getCookie(authConstants.serviceToolsTokenAdmin);
  const sessionId = sessionStorage.getItem(websocketMessageTypes.SESSION_ID);
  const [disconnectSocket] = UseCloseSocketSession();

  const [logout] = useAuthLogoutMutation();


  const onHandleLogout = () => {
    const data = {
      accessToken: currentAccessToken,
      refreshToken: currentRefreshToken,
      serviceToolsTokenAdmin: serviceToolsTokenAdmin
    }

    sessionId && disconnectSocket(sessionId).then(() => {
      sessionStorage.removeItem(websocketMessageTypes.SESSION_ID);

    });

    logout(data).then(({error}) => {
      !error && delLoginCookie();
      !error && dispatch(setLoadAuth(authData(null, false)));

    });

  }

  return (
    <button
      className="border-0 bg-white outline-none"
      style={{height: "24px"}}
      onClick={onHandleLogout}
    >
      <img src={ExitIcon} alt="" className="h-100"/>
    </button>
  );
};

export default LogoutBtn;